import Enterprise16 from '@carbon/icons-react/es/enterprise/16';
import Events16 from '@carbon/icons-react/es/events/16';
import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { Breadcrumb } from 'components/atoms/breadcrumb';
import { PageLoading } from 'components/atoms/loading';
import {
  CompactMenu,
  CompactMenuTitle,
} from 'components/atoms/menu/compact-menu';
import { TeamMembersList } from 'components/organisms/module-settings/partner';
import { PageHeader } from 'components/organisms/module-settings/partner/page-header';
import { Argon } from 'components/templates';
import { RoutePaths } from 'constant';
import {
  useGetAllPartnerCompanies,
  useGetAllPartnerPermissions,
} from 'queries/partner';
// eslint-disable-next-line import/no-internal-modules
import { NotFound } from 'routes/404';

export const PartnerTeamMembers: FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: partners, isLoading: isPartnersLoading } =
    useGetAllPartnerCompanies();
  const { isLoading: isPartnerPermissionsLoading } =
    useGetAllPartnerPermissions();
  const partner = useMemo(
    () => (partners ?? []).find((x) => x.companyId === parseInt(id, 10)),
    [id, partners],
  );
  const { push } = useHistory();

  return isPartnersLoading || isPartnerPermissionsLoading ? (
    <PageLoading />
  ) : partner != null ? (
    <Argon
      actions={{}}
      title={<PageHeader partner={partner} />}
      breadcrumbs={
        <Breadcrumb.Item>
          <Link to={RoutePaths.partner}>
            <FormattedMessage id="partners" />
          </Link>
        </Breadcrumb.Item>
      }
      tabs={
        <CompactMenu mode="horizontal" selectedKeys={['team_members']}>
          <CompactMenu.Item
            key="profile"
            onClick={() =>
              push(
                `${RoutePaths.partner}${RoutePaths.partnerInformation.replace(
                  ':id',
                  id,
                )}`,
              )
            }
          >
            <CompactMenuTitle
              icon={<Enterprise16 />}
              text={<FormattedMessage id="profile" />}
            />
          </CompactMenu.Item>
          <CompactMenu.Item key="team_members">
            <CompactMenuTitle
              icon={<Events16 />}
              text={<FormattedMessage id="partners.detail.tabs.team_members" />}
            />
          </CompactMenu.Item>
        </CompactMenu>
      }
      content={<TeamMembersList partner={partner} />}
    />
  ) : (
    <NotFound />
  );
};
